import { render, staticRenderFns } from "./PayWay.vue?vue&type=template&id=8365a0e2&scoped=true"
import script from "./PayWay.vue?vue&type=script&lang=js"
export * from "./PayWay.vue?vue&type=script&lang=js"
import style0 from "./PayWay.vue?vue&type=style&index=0&id=8365a0e2&prod&lang=scss"
import style1 from "./PayWay.vue?vue&type=style&index=1&id=8365a0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8365a0e2",
  null
  
)

export default component.exports